import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";

const DeleteAccountDialog = ({ open, onClose, onConfirm }) => {
  const [checked, setChecked] = useState(false);

  const handleConfirm = () => {
    if (checked) onConfirm();
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="delete-account-title">
      <DialogTitle id="delete-account-title">Delete Account</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          This will permanently delete your account and all your data from our database.
        </Typography>
        <FormControlLabel
          control={<Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)} />}
          label="I understand this action cannot be undone."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="error" disabled={!checked} onClick={handleConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAccountDialog;
